import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './components/navigation/menu/menu.component';
import { TapToTopComponent } from './components/tap-to-top/tap-to-top.component';
import { RouterModule } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { LoaderComponent } from './components/loader/loader.component';
import { SplitNoSidebarComponent } from '@blog/blog-list-creative/split-no-sidebar/split-no-sidebar.component';
import { BreadcrumbGalleryComponent } from '@shared/components/breadcrumb-gallery/breadcrumb-gallery.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { AccordionComponent } from '@shared/components/accordion/accordion.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ContactComponent } from '@shared/components/contact/contact.component';
import { EventScheduleComponent } from '@shared/components/event-schedule/event-schedule.component';
import { EventAboutComponent } from '@shared/components/event-about/event-about.component';
import { FootStepsAnimationsComponent } from './components/foot-steps-animations/foot-steps-animations.component';
import { PortfolioGalleryComponent } from '@shared/components/portfolio-gallery/portfolio-gallery.component';
import { ZoomGalleryComponent } from '@shared/components/zoom-gallery/zoom-gallery.component';
import { GalleryModule } from '@ks89/angular-modal-gallery';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    MenuComponent,
    TapToTopComponent,
    LoaderComponent,
    SplitNoSidebarComponent,
    BreadcrumbGalleryComponent,
    AccordionComponent,
    ContactComponent,
    EventScheduleComponent,
    EventAboutComponent,
    FootStepsAnimationsComponent,
    PortfolioGalleryComponent,
    ZoomGalleryComponent
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    MenuComponent,
    LoaderComponent,
    TapToTopComponent,
    SplitNoSidebarComponent,
    BreadcrumbGalleryComponent,
    CarouselModule,
    AccordionComponent,
    NgbModule,
    ContactComponent,
    EventScheduleComponent,
    EventAboutComponent,
    FootStepsAnimationsComponent,
    PortfolioGalleryComponent,
    ZoomGalleryComponent,
    GalleryModule
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ToastrModule.forRoot(),
    CarouselModule,
    NgbModule,
    GalleryModule
  ]
})
export class SharedModule { }
